import React from 'react';
type ConfidenceBadgeProps = {
  score: number;
  size?: 'sm' | 'md' | 'lg';
};
export function ConfidenceBadge({
  score,
  size = 'md'
}: ConfidenceBadgeProps) {
  const getColorClasses = () => {
    if (score >= 90) return 'bg-green-100 text-green-700 border-green-200';
    if (score >= 75) return 'bg-yellow-100 text-yellow-700 border-yellow-200';
    return 'bg-red-100 text-red-700 border-red-200';
  };
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'w-10 h-10 text-xs';
      case 'lg':
        return 'w-16 h-16 text-lg';
      default:
        return 'w-12 h-12 text-sm';
    }
  };
  return <div className={`${getSizeClasses()} ${getColorClasses()} rounded-full border-2 flex items-center justify-center font-bold`} role="status" aria-label={`${score}% confidence match`} data-id="element-27">
      {score}%
    </div>;
}